import Vue from 'vue';
import Router from 'vue-router';
import Media from './views/Media.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:uniqueId/default',
      name: 'default',
      component: Media,
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.query.autoplay) {
          to.params.autoplay = to.query.autoplay === 'true';
        }

        if (to.query.debug) {
          to.params.debug = to.query.debug === 'true';
        }

        if (to.query.direct) {
          to.params.direct = to.query.direct === 'true';
        }

        if (to.query.userId) {
          to.params.userId = to.query.userId;
        }

        if (to.query.lang) {
          to.params.lang = to.query.lang;
        }

        next();
      },
    },
    {
      path: '/legacy/:accountId/default',
      name: 'default',
      component: Media,
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.query.autoplay) {
          to.params.autoplay = to.query.autoplay === 'true';
        }

        if (to.query.debug) {
          to.params.debug = to.query.debug === 'true';
        }

        if (to.query.direct) {
          to.params.direct = to.query.direct === 'true';
        }

        if (to.query.legacyId) {
          to.params.legacyId = to.query.legacyId;
        }

        if (to.query.accountId) {
          to.params.accountId = to.query.accountId;
        }

        if (to.query.userId) {
          to.params.userId = to.query.userId;
        }

        if (to.query.lang) {
          to.params.lang = to.query.lang;
        }

        next();
      },
    },
    // todo - not found & logger
  ],
});
